const MOBILEREG = /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/;

const MobileValidate = {
	getMessage(field, args) {
		return 'Format incorrect';
	},
	validate(value, args) {
		// console.log(MOBILEREG.test(value), value)
		return MOBILEREG.test(value);
	}
};
